import { jsx as _jsx } from "react/jsx-runtime";
import { ElementRenderer, generateElementKey } from '../ElementRenderer.js';
import { getLayoutStyles } from '../layout.js';
import { cn } from '../lib/utils.js';
/**
 * Footer element with proper styling
 * Adds background and border-top for visual separation
 */
export function Footer({ element }) {
    const layoutStyles = getLayoutStyles(element);
    const { props } = element;
    // Check if sticky
    const isSticky = props.sticky === true;
    return (_jsx("footer", { className: cn('box-border bg-background border-t border-border', isSticky && 'z-10'), style: layoutStyles, children: element.children.map((child, index) => (_jsx(ElementRenderer, { node: child }, generateElementKey(child, index)))) }));
}
//# sourceMappingURL=Footer.js.map